import {Entry} from './Entry'

import type {XcNwBlock_BlockPricingTableType_Fragment} from '@sdox/api'

export const BlockPricingTable = ({
  pricingTableTitle,
  units,
  total,
  description,
}: XcNwBlock_BlockPricingTableType_Fragment) => (
  <div>
    <p className={'max-w-text pb-spacing-20 text-p1'}>{pricingTableTitle}</p>
    <div className={'flex flex-col gap-spacing-12'}>
      {units.map(({id, key, value}) => (
        <Entry
          key={id}
          label={key}
          value={<p>{value}</p>}
        />
      ))}
      <Entry
        className={'border-t-1 border-outline-secondary pt-spacing-12'}
        label={total.key}
        value={<p className={'font-semibold'}>{total.value}</p>}
      />
    </div>
    <p className={'max-w-text pt-spacing-32 text-p2 text-glyph-default-secondary'}>{description}</p>
  </div>
)